import React from 'react';
import { LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
interface TrustBadgesProps {
  className?: string;
}
export function TrustBadges({
  className = ''
}: TrustBadgesProps) {
  return <div className={`mt-6 space-y-3 ${className}`} data-id="element-659">
      <p className="font-body text-sm text-gray-400 flex items-center justify-center gap-2" data-id="element-660">
        <LockKeyholeIcon className="w-4 h-4 text-gold" aria-hidden="true" data-id="element-661" />
        <span data-id="element-662">Pago 100% Seguro y Encriptado</span>
      </p>
      <p className="font-body text-sm text-gray-400 flex items-start justify-center gap-2 max-w-2xl mx-auto text-left sm:text-center" data-id="element-663">
        <ShieldCheckIcon className="w-4 h-4 text-gold mt-0.5 shrink-0" aria-hidden="true" data-id="element-664" />
        <span data-id="element-665">
          Garantía de 30 Días Basada en Acción: Si usas el sistema, contactas a
          10 negocios y no consigues ningún cliente interesado, te devolvemos el
          100% de tu dinero
        </span>
      </p>
    </div>;
}